<template>
  <div>
    <div v-show="show == 0">
      <!-- 骨架屏 -->
      <skeleton-screen v-show="!dataLoaded"></skeleton-screen>
      <div v-if="dataLoaded" class="col-md-12 col-sm-12 col-lg-12 col-xl-12 d-flex pl-0 pr-0 ml-0 justify-content-between sjtop boxClass">
        <div class="parent heggs scroll-container yuanjiao boxClass" style="width: calc(100% - 21vw)">
          <!-- 上半部分 -->
          <div class="col-sm-12 baise yuanjiao pl-0 pr-0" id="zhixingld">
            <!-- <img v-if="bannerLis.length == 0" style="width: 100%;" src="" alt="" /> -->

            <b-carousel id="carousel-fade" v-if="bannerLis.length > 0"  style="text-shadow: 0px 0px 2px #000;height: 400px;border-radius: 12px 12px 0 0;" fade indicators img-width="1024" img-height="100" class="imase  sjbgaodu yinc yuanjiao">
              <b-carousel-slide v-for="(item, index) in bannerLis" :key="index" caption="" :img-src="item"></b-carousel-slide>
            </b-carousel>
            <b-carousel id="carousel-fade" v-if="bannerLis.length > 0" style="text-shadow: 0px 0px 2px #000;border-radius: 12px 12px 0 0;object-fit: cover;" fade indicators img-width="1024" img-height="100" class="aaaa yuanjiao">
              <b-carousel-slide v-for="(item, index) in bannerLis" :key="index" caption="" :img-src="item"></b-carousel-slide>
            </b-carousel>

            <div class="p-4 sjiduand1">
              <div class="col-sm-12 pl-0 pr-0 d-flex justify-content-between" style="align-items: center;">
                <div class="col-sm-12 col-lg-8 col-xl-9 pl-0 pr-0">
                  <!-- pc -->
                  <div class="d-flex justify-content-between pl-0 pr-0 col-sm-12 mb-3 yinc">
                    <div class="col-sm-8 col-md-8 col-lg-7 col-xl-8 pl-0 pr-0">
                      <div class="mb-3" style="font-size: calc(12px + 0.4vw);font-weight: 700;">
                        {{ detailInfo.name }}
                      </div>
                      <span class="mt-2 mb-2 pl-3 pr-3 pt-2 pb-2" style="font-size: calc(7px + 0.4vw);background-color: #FFFAF0;">
                        {{ detailInfo.category_name }}
                      </span>
                    </div>
                    <div class="d-flex col-sm-4 mt-2 col-md-4 col-lg-5 col-xl-5 pl-0 pr-0">
                      <div class="jhsad col-sm-4 mr-2">
                        <div>
                          <div style="font-size: calc(8px + 0.4vw);font-weight: 700;">
                            {{ detailInfo.moment_num ? detailInfo.moment_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                          </div>
                          <div style="font-size: calc(6px + 0.4vw);">{{ $t("贴文") }}</div>
                        </div>
                      </div>
                      <div class="jhsad col-sm-4 mr-2" style="background: #FDDDC9;">
                        <div>
                          <div style="font-size: calc(8px + 0.4vw);font-weight: 700;">
                            {{ detailInfo.member_num ? detailInfo.member_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                          </div>
                          <div style="font-size: calc(6px + 0.4vw);">{{ $t("成员") }}</div>
                        </div>
                      </div>
                      <div class="jhsad col-sm-4" style="background: #FFEBD2;">
                        <div>
                          <div style="font-size: calc(8px + 0.4vw);font-weight: 700;">
                            {{ detailInfo.volunteer_num ? detailInfo.volunteer_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                          </div>
                          <div style="font-size: calc(6px + 0.4vw);">{{ $t("志工") }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class=" mb-2 aaaa" style="width: 100%;">
                    <div class="d-flex" style="width: 100%;">
                      <div class="aaaa pl-0 pr-0 yuanjiao" style="margin-top: -7vh;z-index: 998;display: block;">
                        <img style="width: 100px;object-fit: cover;" class="yuanjiao" v-if="detailInfo.logo" :src="detailInfo.logo" alt="" />
                        <img style="width: 100%;" class="yuanjiao" v-else src="" alt="" />
                      </div>
                      <div class="ml-2" style="width: 100%;">
                        <div class="mb-2 sjtoto" style="font-size: calc(12px + 0.4vw);font-weight: 700;">
                          {{ detailInfo.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="aaaa">
                    <div class="d-flex justify-content-between" style="align-items: center;">
                      <div class="pl-3 pr-3 pt-2 pb-2 sjbxzt" style="background-color: #FFFAF0;max-width: 37%;">
                        {{ detailInfo.category_name }}
                      </div>
                      <div class="d-flex justify-content-between" style="width: 62%;">
                        <div class="jhsad mr-2" style="width: 33%;">
                          <div>
                            <div style="font-size: calc(14px + 0.4vw);font-weight: 700;">
                              {{ detailInfo.moment_num ? detailInfo.moment_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                            </div>
                            <div style="font-size: calc(10px + 0.4vw);">{{ $t("贴文") }}</div>
                          </div>
                        </div>
                        <div class="jhsad mr-2" style="background: #FDDDC9;width: 33%;">
                          <div>
                            <div style="font-size: calc(14px + 0.4vw);font-weight: 700;">
                              {{ detailInfo.member_num ? detailInfo.member_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                            </div>
                            <div style="font-size: calc(10px + 0.4vw);">{{ $t("成员") }}</div>
                          </div>
                        </div>
                        <div class="jhsad" style="background: #FFEBD2;width: 33%;">
                          <div>
                            <div style="font-size: calc(14px + 0.4vw);font-weight: 700;">
                              {{ detailInfo.volunteer_num ? detailInfo.volunteer_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                            </div>
                            <div style="font-size: calc(10px + 0.4vw);">{{ $t("志工") }}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div style="height: 1rem;width: 100%;"></div>
                  <!-- 手机 -->
                  <div class="sjbxzt" style="color: #666666;font-size: calc(6px + 0.4vw);" v-html="formattedDescription(detailInfo.introduction)"></div>
                  <div class="mt-3 yinc" v-if="aboutUs.business_number||aboutUs.tel||aboutUs.email">
                    <div class="d-flex align-items-center">
                      <div class="d-flex justify-content-between align-items-center mr-2" v-if="aboutUs.business_number">
                        <div class="mr-1"><img style="width: calc(20px + 0.4vw);height: calc(20px + 0.4vw);" src="@/img/icon_grzx_tb@2x.png" alt=""></div>
                        <div style="font-size: calc(7px + 0.4vw);color: #666666;">{{ $t("統編") }}：{{ aboutUs.business_number }}</div>
                      </div>
                      <div class="d-flex justify-content-between align-items-center mr-2" v-if="aboutUs.tel">
                        <div class="mr-1"><img style="width: calc(20px + 0.4vw);height: calc(20px + 0.4vw);" src="@/img/icon_grzx_iphone@2x (1).png" alt=""></div>
                        <div style="font-size: calc(7px + 0.4vw);color: #666666;">{{ $t("電話") }}：{{ aboutUs.tel }}</div>
                      </div>
                      <div class="d-flex justify-content-between align-items-center mr-2" v-if="aboutUs.email">
                        <div class="mr-1"><img style="width: calc(20px + 0.4vw);height: calc(20px + 0.4vw);" src="@/img/icon_grzx_email@2x (1).png" alt=""></div>
                        <div style="font-size: calc(7px + 0.4vw);color: #666666;">{{ $t("信箱") }}：{{ aboutUs.email }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="aaaa mt-3" v-if="aboutUs.facebook||aboutUs.line||aboutUs.file_ppt||aboutUs.business_number||aboutUs.tel||aboutUs.email">
                    <div class="d-flex mb-3" v-if="!sfoudhj" style="justify-content: center;">
                      <a class="mr-4 curpo" v-if="aboutUs.facebook" :href="aboutUs.facebook"><img style="width: calc(30px + 0.4vw);height: calc(30px + 0.4vw);" src="@/img/grzx/icon_grzx_lj_three@2x.png" alt=""></a>
                      <a class="mr-4 curpo" v-if="aboutUs.line" :href="aboutUs.line"><img style="width: calc(30px + 0.4vw);height: calc(30px + 0.4vw);" src="@/img/icon_grzx_lj_six@2x.png" alt=""></a>
                      <div class="curpo" v-if="aboutUs.file_ppt" @click="downloadPPT(aboutUs.file_ppt,aboutUs.file_name)"><img style="width: calc(30px + 0.4vw);height: calc(30px + 0.4vw);" src="@/img/icon_grzx_pdf@2x.png" alt=""></div>
                    </div>
                    <div class="mb-3" v-if="!sfoudhj">
                      <div v-if="aboutUs.business_number" class="d-flex justify-content-between align-items-center yuanjiao pt-2 pb-2 pl-3 pr-3 mb-2" style="background: #FFFAF0;">
                        <div class="d-flex align-items-center">
                          <div class="mr-1"><img style="width: calc(25px + 0.4vw);height: calc(25px + 0.4vw);" src="@/img/icon_grzx_tb@2x.png" alt=""></div>
                          <div class="sjbxzt">{{ $t("統編") }}：</div>
                        </div>
                        <div class="sjbxzt" style="font-size: calc(7px + 0.4vw);">{{ aboutUs.business_number }}</div>
                      </div>
                      <div v-if="aboutUs.tel" class="d-flex justify-content-between align-items-center yuanjiao pt-2 pb-2 pl-3 pr-3 mb-2" style="background: #FFFAF0;">
                        <div class="d-flex align-items-center">
                          <div class="mr-1"><img style="width: calc(25px + 0.4vw);height: calc(25px + 0.4vw);" src="@/img/icon_grzx_iphone@2x (1).png" alt=""></div>
                          <div class="sjbxzt">{{ $t("電話") }}：</div>
                        </div>
                        <div class="sjbxzt" style="font-size: calc(7px + 0.4vw);">{{ aboutUs.tel }}</div>
                      </div>
                      <div v-if="aboutUs.email" class="d-flex justify-content-between align-items-center yuanjiao pt-2 pb-2 pl-3 pr-3" style="background: #FFFAF0;">
                        <div class="d-flex align-items-center">
                          <div class="mr-1"><img style="width: calc(25px + 0.4vw);height: calc(25px + 0.4vw);" src="@/img/icon_grzx_email@2x (1).png" alt=""></div>
                          <div class="sjbxzt">{{ $t("信箱") }}：</div>
                        </div>
                        <div class="sjbxzt" style="font-size: calc(7px + 0.4vw);">{{ aboutUs.email }}</div>
                      </div>
                    </div>
                    <div class="d-flex" style="justify-content: center;">
                      <div class="d-flex align-items-center curpo" @click="sfoudhj = !sfoudhj">
                        <div class="sjbxzt mr-2">{{ sfoudhj ? $t("展開更多") : $t("收回更多") }}</div>
                        <div>
                          <img v-if="sfoudhj" style="width: 25px;height: 25px;" src="@/img/icon_zhankai@2x.png" alt="">
                          <img v-else style="width: 25px;height: 25px;" src="@/img/icon_shouhui@2x.png" alt="">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="yinc">
                    <div class="d-flex justify-content-between " style="align-items: center;">
                      <!-- <div @click="bulletframe()" class="mr-3 pl-4 pr-4 pt-3 pb-3 yuanjiao curpo ckqbb mt-3 mb-3 sjbzt" style="font-size: calc(7px + 0.4vw);background: #FFD672;border: none;color: #000;" v-if="detailInfo.is_member == 0">
                        {{ $t("加入团体") }}
                      </div> -->
                      <div @click="backrame()" class="mr-3 pl-4 pr-4 pt-3 pb-3 yuanjiao curpo ckqbb mt-3 mb-3 sjbzt" style="font-size: calc(7px + 0.4vw);background: #F6F4F0;border: none;color: #000;" v-if="detailInfo.is_member == 1">
                        {{ $t("离开团体") }}
                      </div>
                      <!-- <button @click='show=1' class="pl-4 pr-4 pt-3 pb-3 yuanjiao curpo ckqbb mt-4"
												style="font-size: calc(6px + 0.4vw);background: #FAB1AB;border: none;">
												{{ $t("关联组织") }}
											</button> -->
                    </div>
                  </div>
                  <div class="aaaa">
                    <div>
                      <div @click="bulletframe()" class="pl-4 pr-4 pt-3 pb-3 yuanjiao curpo ckqbb mt-3 mb-3 sjbzt text-center" style="font-size: calc(7px + 0.4vw);background: #FFD672;border: none;color: #000;margin: auto;width: 55%;" v-if="detailInfo.is_member == 0">
                        {{ $t("加入团体") }}
                      </div>
                      <div @click="backrame()" class="pl-4 pr-4 pt-3 pb-3 yuanjiao curpo ckqbb mt-3 mb-3 sjbzt text-center" style="font-size: calc(7px + 0.4vw);background: #F6F4F0;border: none;color: #000;margin: auto;width: 55%;" v-if="detailInfo.is_member == 1">
                        {{ $t("离开团体") }}
                      </div>
                      <!-- <button @click='show=1' class="pl-4 pr-4 pt-3 pb-3 yuanjiao curpo ckqbb mt-4"
												style="font-size: calc(6px + 0.4vw);background: #FAB1AB;border: none;">
												{{ $t("关联组织") }}
											</button> -->
                    </div>
                  </div>
                </div>
                <div class="col-md-4 col-lg-3 col-xl-2 tpiand pl-0 pr-0">
                  <div><img style="width: 100%;height: 200px;object-fit: cover;" class="yuanjiao" :src="detailInfo.logo || ''" alt="" /></div>
                  <div class="d-flex mt-2" style="justify-content: center;" v-if="aboutUs.facebook||aboutUs.line||aboutUs.file_ppt">
                    <a class="mr-2 curpo" v-if="aboutUs.facebook" :href="aboutUs.facebook"><img style="width: calc(20px + 0.4vw);height: calc(20px + 0.4vw);" src="@/img/grzx/icon_grzx_lj_three@2x.png" alt=""></a>
                    <a class="mr-2 curpo" v-if="aboutUs.line" :href="aboutUs.line"><img style="width: calc(20px + 0.4vw);height: calc(20px + 0.4vw);" src="@/img/icon_grzx_lj_six@2x.png" alt=""></a>
                    <div class="curpo" v-if="aboutUs.file_ppt" @click="downloadPPT(aboutUs.file_ppt,aboutUs.file_name)"><img style="width: calc(20px + 0.4vw);height: calc(20px + 0.4vw);" src="@/img/icon_grzx_pdf@2x.png" alt=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 中间部分 -->
          <div class="col-sm-12 pl-0 pr-0 items mt-3 yinc" @mouseenter="showButtons = true" @mouseleave="showButtons = false">
            <div class="col-sm-12 pl-0 pr-0 position-relative d-flex justify-content-between align-items-center">
              <div v-show="showButtons" class="col-auto position-absolute pl-0 pr-0 dcbd curpo xsdann" style="z-index: 999;left: 0;" @click="move(-1)">
                <img style="width: calc(12px + 0.5vw);" src="@/img/details/icon_jklb_xiangzuo@2x.png" alt="" />
              </div>
              <div class="col-sm-12 d-flex pl-0 pr-0 d-flex" style="justify-content: flex-start;">
                <div @click="wautobutt(item.id)" class=" ckqbb  curpo yuanjiao pt-3 pb-3 position-relative mr-3" style="background: #FFFFFF;text-align: center;width: 19%;" v-for="(item, index) in visibleItems" :key="index">
                  <!-- 假设每个item是一个对象，包含图标和文字 -->
                  <img class="mb-1" style="width: calc(13px + 0.5vw);" :src="item.icon" alt="" />
                  <div style="text-align: center;width: 100%;font-size: calc(8px + 0.4vw);">
                    {{ item.text }}
                  </div>
                  <div v-show="item.id == wauto" class="position-absolute" style="height: 2px;width: 74%;bottom: 0;background: #FFD672;left: 13%;"></div>
                </div>
              </div>
              <div v-show="showButtons" class="col-auto position-absolute pl-0 pr-0 dcbd curpo xsdann" style="z-index: 999;right: 0;" @click="move(1)">
                <img style="width: calc(12px + 0.5vw);" src="@/img/details/icon_jklb_xiangyou@2x.png" alt="" />
              </div>
            </div>
          </div>
          <div class="items mt-3 aaaa" style="width: 100%;position: relative;" id="clickTab">
            <div class="col-auto position-absolute pl-0 pr-0 dcbd curpo xsdann" style="z-index: 999;left: 0;top: 34%;">
              <img style="width: calc(12px + 0.5vw);" src="@/img/details/icon_jklb_xiangzuo@2x.png" alt="" />
            </div>
            <div class="d-flex align-items-center parent" style="width: 100%;overflow-x: auto;white-space: nowrap;">

              <div style="width: 100%;display: inline-block;">
                <div @click="wautobutt(item.id)" class=" mr-3  yuanjiao pt-3 pb-3 sjdsdsax" v-for="(item, index) in allItems" :key="index">
                  <!-- 假设每个item是一个对象，包含图标和文字 -->
                  <img class="mb-1" style="width: calc(16px + 0.5vw);" :src="item.icon" alt="" />
                  <div class="sjbzt" style="text-align: center;width: 100%;font-size: calc(10px + 0.4vw);">
                    {{ item.text }}
                  </div>
                  <div v-show="item.id == wauto" class="position-absolute" style="height: 2px;width: 74%;bottom: 0;background: #FFD672;left: 13%;"></div>
                </div>
              </div>

            </div>
            <div class="col-auto position-absolute pl-0 pr-0 dcbd curpo xsdann" style="z-index: 999;right: 0;bottom: 34%;">
              <img style="width: calc(12px + 0.5vw);" src="@/img/details/icon_jklb_xiangyou@2x.png" alt="" />
            </div>
          </div>
          <!-- 切换的下半部分  拼音 -->
          <router-view />
          <!-- <wzzc :isinfozao="infozao" :isids="id" v-if="wauto == 8"></wzzc> -->

        </div>
        <div v-if="showImage" class="curpo" style="position: fixed;right: 5%;bottom: 10%;z-index: 999999999">
          <img @click="scrollToSection('zhixingld')" style="width: calc(36px + 0.4vw);height: calc(36px + 0.4vw);" src="@/img/icon_hssy_zhiding@2x.png" alt="">
        </div>
        <!-- 右边导航 -->
        <div class="yuanjiao col-xl-3 yinc ml-0 pr-0 pl-1 baise leftSidebarBox" ref="leftSidebarBox" style="position: fixed;right: 1.8vw;flex:1;max-width:20vw;top:9.5vh;max-height: 86.5vh;overflow-y: auto;">
          <div>

            <div style="height: 84.5vh" v-if="wauto != 4 && wauto != 2 && wauto != 6 && wauto != 7">
              <div class=" col-md-12 yuanjiao pl-0 pr-0 mb-1"  >
                <div class="mb-2 d-flex justify-content-between ml-3 mr-3 pt-3" style="font-size: calc(8px + 0.4vw); font-weight: 500">
                  <div>{{ $t("捐款列表") }}</div>
                  <!-- <div class="ckq curpo" style="color: #ffd672">
                    {{ $t("查看全部") }}
                  </div> -->
                </div>
                <div class="mb-1 ml-3 mr-3 col-md-11" style="height: 1px; background: #e5e5e5"></div>
                <div v-show="index <= 4" @click="zjsyqk(item.id)" v-for="(item, index) in used" :key="index" class="d-flex justify-content-between ckqbb curpo align-items-center mb-2 xunafuxgio pl-3 pr-3 pt-2 pb-2 yuanjiao">
                  <div class="d-flex justify-content-between align-items-center">
                    <img class="mr-2" style="width: calc(35px + 0.5vw);height: calc(35px + 0.4vw);border-radius: 50%;object-fit: cover;" :src="item.image" alt="" />
                    <div>
                      <div class="ellipsis" style="font-size: calc(7px + 0.4vw); white-space: nowrap; overflow: hidden;text-overflow: ellipsis;max-width: 11vw;">
                        {{ item.name }}
                      </div>
                      <div class="d-flex align-items-center mt-1">
                        <div class="d-flex mr-2 align-items-center" style="font-size: calc(6px + 0.4vw);color: #666666;">
                          <img style="width: calc(7px + 0.5vw);height: calc(7px + 0.5vw);" src="@/img/daohangl/icon_jkhd_qian@2x.png" alt="" />
                          <div class="ml-1">{{ item.used_amount ? item.used_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
                        </div>
                        <div class="d-flex mr-3 align-items-center" style="font-size: calc(6px + 0.4vw); color: #666666">
                          <img style="
                          width: calc(7px + 0.5vw);
                          height: calc(7px + 0.5vw);
                        " src="@/img/icon_jkhd_shijain@2x.png" alt="" />
                          <div class="ml-1">{{ timeFilter(item.expiry_date) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <img style="width: calc(15px + 0.5vw)" src="@/img/daohangl/icon_hssy_hdlb_xiangqing@2x.png" alt="" />
                </div>
              </div>
              <div class="baise col-md-12  yuanjiao pl-0 pr-0" >
                <div class="mb-1 d-flex justify-content-between ml-3 mr-3 pt-3" style="font-size: calc(8px + 0.4vw); font-weight: 500">
                  <div>{{ $t("志工活動列表") }}</div>
                  <!-- <div class="ckq curpo" style="color: #ffd672" @click="funs()">
                    {{ $t("查看全部") }}
                  </div> -->
                </div>
                <div class="mb-2 ml-3 mr-3 col-md-11" style="height: 1px; background: #e5e5e5"></div>
                <div v-show="index <= 4" @click="funs(item)" v-for="(item, index) in activity" :key="index" class="d-flex curpo ckqbb justify-content-between align-items-center mb-2 xunafuxgio pl-3 pr-3 pt-2 pb-2 yuanjiao">
                  <div class="d-flex justify-content-between align-items-center">
                    <img class="mr-2" style="width: calc(35px + 0.5vw);height: calc(35px + 0.4vw);border-radius: 50%;object-fit: cover;" :src="item.image" alt="" />
                    <div>
                      <div class="ellipsis" style="font-size: calc(7px + 0.4vw);width: calc(125px + 0.5vw);">
                        {{ item.name }}
                      </div>
                      <div class="d-flex align-items-center mt-1">
                        <div class="d-flex mr-3 align-items-center" style="font-size: calc(6px + 0.4vw); color: #666666">
                          <img style="
                              width: calc(7px + 0.5vw);
                              height: calc(7px + 0.5vw);
                            " src="@/img/daohangl/icon_hssy_hdlb_tiewen@2x.png" alt="" />
                          <div class="ml-1">{{ item.moment_num ? item.moment_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
                        </div>
                        <div class="d-flex align-items-center" style="font-size: calc(5px + 0.4vw); color: #666666">
                          <img style="
                              width: calc(7px + 0.5vw);
                              height: calc(7px + 0.5vw);
                            " src="@/img/daohangl/icon_hssy_hdlb_renyuan@2x.png" alt="" />
                          <div class="ml-1">{{ item.member_num ? item.member_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <img style="width: calc(15px + 0.5vw)" src="@/img/daohangl/icon_hssy_hdlb_xiangqing@2x.png" alt="" />
                </div>
              </div>
            </div>
            <div style="height: 84.5vh" v-if="wauto == 2">
              <div class=" col-md-12 yuanjiao pl-0 pr-0 mb-1"  >
                <div class="mb-2 d-flex justify-content-between ml-3 mr-3 pt-3" style="font-size: calc(8px + 0.4vw); font-weight: 500">
                  <div>{{ $t("資金使用率") }}</div>
                  <!-- <div class="ckq curpo" style="color: #ffd672">
                    {{ $t("查看全部") }}
                  </div> -->
                </div>
                <div class="mb-1 ml-3 mr-3 col-md-11" style="height: 1px; background: #e5e5e5"></div>
                <div v-show="index <= 4" @click="zjsyqk(item.id)" v-for="(item, index) in donationMenuList" :key="index" class="d-flex justify-content-between ckqbb curpo align-items-center mb-2 xunafuxgio pl-3 pr-3 pt-2 pb-2 yuanjiao">
                  <div class="d-flex justify-content-between align-items-center">
                    <img class="mr-2" style="width: calc(35px + 0.5vw);height: calc(35px + 0.4vw);border-radius: 50%;object-fit: cover;" :src="item.image" alt="" />
                    <div>
                      <div class="ellipsis" style="font-size: calc(7px + 0.4vw); white-space: nowrap; overflow: hidden;text-overflow: ellipsis;max-width: 11vw;">
                        {{ item.name }}
                      </div>
  
                      <div class="d-flex align-items-center mt-1">
                        {{ $t("資金使用率") }}: {{ item.received_amount != 0 ?(item.used_amount / item.received_amount * 100).toFixed(1) : '0.0' }}%
                      </div>
                    </div>
                  </div>
                  <img style="width: calc(15px + 0.5vw)" src="@/img/daohangl/icon_hssy_hdlb_xiangqing@2x.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          
        </div>
        <!-- 加入团体弹框 -->
        <b-modal v-model="modalShow" modal-class="custom-modal-width" :no-close-on-backdrop='isLoading' :no-close-on-esc="isLoading" :centered='true' hide-header hide-footer>
          <div style="width: 100%;text-align: center;" class="pb-2 position-relative">
            <img @click="modalShow = false" class="position-absolute curpo dcbd" style="width: calc(15px + 0.5vw);right: 20px;top: -20px;" src="@/img/details/cha.png" alt="" />
            <div class="mb-3 mt-4 sjbzt" style="font-size: calc(9px + 0.4vw);font-weight: 700;">{{ $t('确认加入该团体吗')
							}}</div>
            <div class="p-3 yuanjiao" style="width: 90%;margin: auto;background: #F6F4F0;">
              <div class="sjbxzt" style="font-size: calc(5px + 0.4vw);">
                {{ detailInfo.name }}
              </div>
            </div>
            <div style="height: calc(10px + 1vw);"></div>
            <button :disabled="isLoading" @click="qrbulletframe()" class="pl-5 sjbzt pr-5 pt-3 pb-3 yuanjiao ckqbb curpo annys" style="font-size: calc(6px + 0.4vw);background: #FFD672;border: none;">
              {{ $t('加入团体') }}
              <span v-if="isLoading" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true">
              </span>
            </button>
          </div>
        </b-modal>
      </div>

    </div>
    <glzz v-if="show == 1" @custom="custom"></glzz>

  </div>
</template>

<script>
import SkeletonScreen from "./SkeletonScreen/groupSkeletonScreen.vue";
// import wzzc from "@/components/haosttd/wzzc.vue";
import { EventBus } from "@/views/event-bus.js";
import { donation_list , donation_ActiveLis } from "@/request/aapi.js";
import glzz from "./glzz.vue";
import { team_grounp } from "@/request/aapi.js";
import { expiry, calendar, activity_list } from "@/request/hshd/index.js";
import { formatTimestamp } from "@/utils/common.js";
import {
  group_detail,
  group_team,
  group_join,
  group_leave,
  group_about,
  common_base
} from "@/request/api.js";
export default {
  components: {
    SkeletonScreen,
    // esgphb,
    glzz,
    // wzzc,
  },
  data() {
    return {
      sfoudhj: true,
      show: 0,
      wauto: 1,
      showButtons: false,
      showImage: false, // 是否显示图片
      used: [],
      activity: [],
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      daysOfWeek: [
        this.$t("Sun"),
        this.$t("Mon"),
        this.$t("Tue"),
        this.$t("Wed"),
        this.$t("Thu"),
        this.$t("Fri"),
        this.$t("Sat"),
      ],
      daysInMonth: [],
      xwac: "",
      hongdianlist: [],
      status: 1,
      keywords: "",
      selected: "",
      currentPage:1,
      donationMenuList:[],
      // 假设这是你的所有元素列表
      allItems: [
        {
          id: 1,
          icon: require("@/img/details/icon_ttxq_tuyaqiang@2x.png"),
          value: "moment",
          text: this.$t("涂鸦墙"),
        },
        {
          id: 10,
          icon: require("@/img/details/icon_ttxq_aixinqiye@2x.png"),
          value: "caring-enterprise",
          text: this.$t("爱心企业"),
        },
        {
          id: 2,
          value: "donation",
          icon: require("@/img/details/icon_ttxq_juankuan@2x.png"),
          text: this.$t("捐款"),
        },
        {
          id: 9,
          value: "donate-supplies",
          icon: require("@/img/details/icon_juanwu@1x.png"),
          text: this.$t("捐物"),
        },
        {
          id: 3,
          value: "delivery",
          icon: require("@/img/details/icon_ttxq_yuyuegongyun_hui@2x.png"),
          text: this.$t("预约共运"),
        },
        {
          value: "activity",
          id: 4,
          icon: require("@/img/details/icon_ttxq_jitihuodong@2x.png"),
          text: this.$t("团体活动"),
        },
        // {
        //   id: 5,
        //   icon: require("@/img/details/icon_ttxq_guanyuwomen@2x.png"),
        //   value: "about",
        //   text: this.$t("关于我们"),
        // },
        {
          id: 11,
          icon: require("@/img/icon_yxljh_hei@1x.png"),
          value: "impact-plan",
          text: this.$t("影響力計畫"),
        },
        {
          id: 6,
          icon: require("@/img/details/icon_ttxq_tuantichengyuan@2x.png"),
          value: "member",
          text: this.$t("团体成员"),
        },

        // 假设还有更多元素

        {
          id: 7,
          icon: require("@/img/details/icon_rank@2x.png"),
          text: this.$t("ESG排行榜"),
          value: "ranking",
        },
        {
          id: 8,
          icon: require("@/img/details/icon_ttxq_wuzizaoce@2x.png"),
          value: "material",
          text: this.$t("物资造册"),
        },
      ],
      // 当前显示的元素索引范围
      startIndex: 0,
      // 假设一次显示5个元素
      visibleCount: 5,
      dataLoaded: false,
      modalShow: false,
      isLoading: false,
      detailInfo: {},
      id: 0,
      aboutUs: {},
      chengList: [],
      guanliList: [],
      bannerLis: [],
      infozao: {},
      sectionId:'',
    };
  },
  created() {
    EventBus.$on("call-sibling-b-methods", (msg) => {
      // 执行方法，处理接收到的数据
      // this.message = msg;
      // 如果需要，可以在这里调用其他方法
      this.id = this.$route.params.slug;
      this.getDetail(this.id);
    });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.id = this.$route.params.slug;
    this.getDetail(this.id)
    this.calendar();
    if (this.$route.path.includes("/donation")) {
      this.wauto = 2;
    } else if (this.$route.path.includes("/the_wall")) {
      this.wauto = 1;
    } else if (this.$route.path.includes("/share-car")) {
      this.wauto = 3;
    } else if (this.$route.path.includes("/activity")) {
      this.wauto = 4;
    } else if (this.$route.path.includes("/about-us")) {
      this.wauto = 5;
    } else if (this.$route.path.includes("/members")) {
      this.wauto = 6;
    } else if (this.$route.path.includes("/rank")) {
      this.wauto = 7;
    } else if (this.$route.path.includes("/apply-supplies")) {
      this.wauto = 8;
    } else if (this.$route.path.includes("/donate-supplies")) {
      this.wauto = 9;
    } else if (this.$route.path.includes("/caring-enterprise")) {
      this.wauto = 10;
    } else if (this.$route.path.includes("/impact-plan")) {
      this.wauto = 11;
    } else {
      setTimeout(() => {
        this.wautobutt(1);
      }, 500);
    }
    setTimeout(() => {
      this.checkSidebar();
      // EventBus.$on('check-sidebar', this.checkSidebar);
    },500)
    // 模拟数据加载
  },
  computed: {
    // 计算当前应该显示的元素列表
    visibleItems() {
      return this.allItems.slice(
        this.startIndex,
        this.startIndex + this.visibleCount
      );
    },
    weeksInMonth() {
      let weeks = [];
      let done = false;
      let done1 = true;
      let date = 1;
      const a = this.getDayOfWeek(
        this.currentYear + "-" + this.currentMonth + "-" + "01"
      );
      while (!done) {
        let week = [];
        if (done1) {
          for (let i = 0; i < 7; i++) {
            done1 = false;
            if (date > this.daysInMonth.length) {
              done = true;
              break;
            }
            if (i < a) {
              week.push({ date: "", day: "" });
            } else {
              week.push(this.daysInMonth[date - 1]);
              date++;
            }
          }
        } else {
          for (let i = 0; i < 7; i++) {
            if (date > this.daysInMonth.length) {
              done = true;
              break;
            }
            week.push(this.daysInMonth[date - 1]);
            date++;
          }
        }
        weeks.push(week);
      }
      // console.log(weeks);
      return weeks;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    sessionStorage.clear();
    // 组件销毁前移除监听器，防止内存泄漏
    EventBus.$off("call-sibling-b-methods");
    // EventBus.$off('check-sidebar', this.checkSidebar);
  },
  watch: {
    $route: {
        immediate: true,
        handler(newVal, oldVal) {
            // 当路由变化时执行初始化操作
            if (newVal.path !== oldVal?.path) {
              const savedPosition = sessionStorage.getItem('scrollPosition');
              if(savedPosition) {
                console.log("触发了点击滚动")
                  window.scrollTo(0, Number(savedPosition));
                  sessionStorage.removeItem('scrollPosition');
              }
            }
        }
    }
  },
  methods: {
    checkSidebar() {
      this.$nextTick(() => {
        // console.log('zhzhzhzhzhzh' , this.$refs.leftSidebarBox)
        const exists = !!this.$refs.leftSidebarBox;
        EventBus.$emit('sidebar-status', exists);
      });
    },
    updateVisibleItems() {
      // 计算当前应该显示的列表项索引范围
      const data = {
        organization_id: this.detailInfo.id,
        page: this.currentPage,
        order: this.selected,
        keywords: this.keywords,
      };
      console.log(data , 'data')
      donation_ActiveLis(data).then((res) => {
        if (res.code == 200) {
          this.used = res.data.data;
          this.donationMenuList = res.data.data;
        }
      });
    },
    async activity_list(e) {
      const { data, code } = await activity_list({
        status: this.status,
        organization_id: this.id,
      });
      if (code == 200) {
        this.dataLoaded = true;
      }
      this.listlast_page = data.last_page;
      this.total = data.total;
      this.list = data.data;
      // this.list = [...this.list, ...data.data];
    },
    zjsyqk(e) {
      this.$router.push({
        name: "ckxq",
        params: {
          ckxq: e,
        },
      });
    },
    funs(e) {
      if (e) {
        let a = e.identity == 2 ? "groups" : "enterprises";
        this.$router.push(
          "/activity/" + a + "/" + e.slug + "/" + e.id + "/info"
        );
      } else {
        this.$router.push("/activity");
      }
    },
    // 捐款首页
    getDonation_list() {
      // this.updateVisibleItems()
      const data = {
        organization_id: this.detailInfo.id,
        page: this.currentPage,
        order: this.selected,
        keywords: this.keywords,
      };
      console.log(this.detailInfo.id)
      donation_ActiveLis(data).then((res) => {
        if (res.code == 200) {

          this.used = this.disposeDonationDataList(res.data.data);
        }
      });
    },
    disposeDonationDataList(data){
      let a = new Date().getTime();
      return data.filter((item) => {
        if(a <= item.expiry_date*1000 + 86400000 || item.expiry_date == 0){
          return item
        }
      })
    },
    getActivityList(){
      const data = {
        organization_id: this.detailInfo.id,
        page: this.currentPage,
        order: this.selected,
        keywords: this.keywords,
      };
      activity_list(data).then((res) => {
        this.activity = res.data.data; // 活动信息
        // this.task = res.data.task; // 任务信息
      });
    },
    prevMonth() {
      if (this.currentMonth === 1) {
        this.currentYear--;
        this.currentMonth = 12;
      } else {
        this.currentMonth--;
      }
      this.daysInMonth = this.getDaysInMonth(
        this.currentYear,
        this.currentMonth
      );
      this.calendar();
    },
    nextMonth() {
      if (this.currentMonth === 12) {
        this.currentYear++;
        this.currentMonth = 1;
      } else {
        this.currentMonth++;
      }
      this.daysInMonth = this.getDaysInMonth(
        this.currentYear,
        this.currentMonth
      );
      this.calendar();
    },
    getDaysInMonth(year, month) {
      let days = [];
      let numDays = new Date(year, month, 0).getDate();

      for (let day = 1; day <= numDays; day++) {
        days.push({
          date: day,
          day: day,
        });
      }
      return days;
    },
    xuanzdys(e, v) {
      console.log(e, v);
      if (this.days == e) {
        this.days = "";
        this.xwac = "";
        this.list = [];
        this.activity_list("");
      } else {
        this.days = e;
        this.xwac = v;
        this.list = [];
        this.activity_list(
          this.currentYear + "-" + this.currentMonth + "-" + e
        );
      }
      this.$refs.sidebar.hide();
    },
    isIdEqual(e) {
      return this.hongdianlist.find((item) => item === e) !== undefined;
    },
    getDayOfWeek(dateString) {
      const days = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const date = new Date(dateString);
      const dayIndex = date.getDay();
      // return days[dayIndex];
      return dayIndex;
    },
    async calendar() {
      const { data } = await calendar({
        year: this.currentYear,
        month: this.currentMonth,
        volunteer: this.show,
        status: this.status,
        organization_id: this.id,
      });
      this.hongdianlist = data.data;
    },
    formattedDescription(e){
        return e.replace(/\n/g, '<br>');
    },
    downloadPPT(pptUrl, v) {
      fetch(pptUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error("网络响应失败");
          }
          return response.blob(); // 将响应转换为 Blob 对象
        })
        .then((blob) => {
          // 创建 Blob URL
          const blobUrl = URL.createObjectURL(blob);
          // 创建 <a> 元素并下载
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = v; // 设置下载的文件名
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // 释放 Blob URL
          URL.revokeObjectURL(blobUrl);
        })
        .catch((error) => {
          console.error("下载失败:", error);
        });
    },
    getGroup_about(e) {
      group_about({
        id: e,
      }).then((res) => {
        if (res.data.info) {
          this.aboutUs = res.data.info;
        } else {
          this.aboutUs = {
            content: "",
            email: "",
            facebook: "",
            file_name: "",
            file_ppt: "",
            line: "",
            tel: "",
          };
        }
      });
    },
    scrollToSection(sectionId) {
      this.sectionId = sectionId;
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },

    // 触发分页
    handleScroll() {
      console.log(123, 123);
      // const target = event.target;
      // const scrollDistance =
      //   target.scrollHeight - target.scrollTop - target.clientHeight;

      const scrollTop = window.scrollY; // 页面滚动条距离顶部的距离
      const clientHeight = window.innerHeight; // 可见区域高度
      const scrollHeight = document.documentElement.scrollHeight; // 页面内容总高度
      if (scrollTop > clientHeight) {
        this.showImage = true;
      } else {
        this.showImage = false;
      }
      if (scrollTop + clientHeight >= scrollHeight) {
        // 当滚动条距离底部小于10px时，认为是滚动到底部
        if (this.$route.path.includes("/the_wall")) {
          EventBus.$emit("hsttthe_wall", "tthd");
        } else if (this.$route.path.includes("/donation")) {
          EventBus.$emit("hsttdonation", "tthd");
        } else if (this.$route.path.includes("/share-car")) {
          EventBus.$emit("hsttshare-car", "tthd");
        } else if (this.$route.path.includes("/activity")) {
          EventBus.$emit("hsttactivity", "tthd");
        } else if (this.$route.path.includes("/members")) {
          EventBus.$emit("hsttmembers", "tthd");
        } else if (this.$route.path.includes("/about-us")) {
        } else if (this.$route.path.includes("/rank")) {
        } else if (this.$route.path.includes("/apply-supplies")) {
        } else if (this.$route.path.includes("/donate-supplies")) {
        } else if (this.$route.path.includes("/caring-enterprise")) {
          EventBus.$emit("hsttenterprice", "tthd");
        } else if (this.$route.path.includes("/impact-plan")) {
          EventBus.$emit("hsttimpactplan", "tthd");
        } else {
          EventBus.$emit("hsttthe_wall", "tthd");
        }
      }
    },
    tiewenshul(e) {
      console.log(e);
      if (e == 1) {
        this.detailInfo.moment_num++;
      } else {
        this.detailInfo.moment_num--;
      }
    },
    // 获取团体详情
    getDetail(id) {
      group_detail({
        slug: id,
      }).then((res) => {
        this.getGroup_about(res.data.info.id);
        if (res.code == 200) {
          this.dataLoaded = true;
        }
        // console.log("团体详情", res);
        this.detailInfo = res.data.info;
        this.bannerLis = res.data.info.banner;

        let menu = res.data.info.menu;
        // 筛选显示目录
        let filteredArray = this.allItems.filter((obj) =>
          menu.includes(obj.value)
        );
        this.allItems = filteredArray;
        localStorage.setItem("is_member", this.detailInfo.is_member);
        setTimeout(() => {
          EventBus.$emit("ttchuanrusffb", this.detailInfo.is_member);
          EventBus.$emit("asdpeople", this.detailInfo.people);
        }, 100);
        this.getDonation_list()
        this.getActivityList()
        // this.wautobutt(1)
      });
    },

    // 获取团队成员
    getGroup_team(account) {
      group_team({
        id: this.id,
        is_admin: -1,
        account: account,
      }).then((res) => {
        console.log(res, "团队成员");
        this.chengList = res.data.data;
      });
    },

    // 获取团队管理员
    getGroup_team_guanli() {
      group_team({
        id: this.id,
        is_admin: 1,
      }).then((res) => {
        // console.log(res, "团队管理员");
        this.guanliList = res.data.data;
      });
    },

    custom() {
      this.show = 0;
    },
    // 时间转换
    timeFilter(stringTime) {
      if(stringTime == 0){
        return "長期集資"
      }
      return formatTimestamp(stringTime * 1000);
    },
    wautobutt(e) {
      sessionStorage.setItem('scrollPosition', window.pageYOffset || document.documentElement.scrollTop);
      this.wauto = e;
      if (e == 2) {
        this.updateVisibleItems()
        this.$router.push({
          name: "ttdonation",
          params: {
            id: this.detailInfo.id,
          },
          _position: window.pageYOffset || document.documentElement.scrollTop // 记录当前滚动位置
        });
      } else if (e == 1) {
        this.$router.push({
          name: "tttuyaqiang",
          params: {
            id: this.detailInfo.id,
            is_member: this.detailInfo.is_member,
          },
          _position: window.pageYOffset || document.documentElement.scrollTop // 记录当前滚动位置
        });
      } else if (e == 4) {
        this.$router.push({
          name: "tuabduihd",
          params: {
            id: this.detailInfo.id,
          },
          query: { 
            type: 'GroupJump',
          },
          _position: window.pageYOffset || document.documentElement.scrollTop // 记录当前滚动位置
        });
      } else if (e == 3) {
        this.$router.push({ 
          name: "yuygy",
          _position: window.pageYOffset || document.documentElement.scrollTop // 记录当前滚动位置
        });
      } else if (e == 5) {
        this.$router.push({
          name: "guanywm",
          params: {
            id: this.detailInfo.id,
          },
          _position: window.pageYOffset || document.documentElement.scrollTop // 记录当前滚动位置
        });
      } else if (e == 6) {
        this.$router.push({
          name: "tuanduicy",
          params: {
            id: this.detailInfo.id,
          },
          query: { 
            type: 'GroupJump',
          },
          _position: window.pageYOffset || document.documentElement.scrollTop // 记录当前滚动位置
        });
      } else if (e == 7) {
        this.$router.push({
          name: "esgphb",
          params: {
            id: this.detailInfo.id,
          },
          query: { 
            type: 'GroupJump',
          },
        });
      } else if (e == 8) {
        this.$router.push({
          name: "wzzc",
          params: {
            id: this.detailInfo.id,
          },
        });
      } else if (e == 9) {
        this.$router.push({
          name: "supplies",
          params: {
            id: this.detailInfo.id,
          },
        });
      } else if (e == 10) {
        this.$router.push({
          name: "caringEnterprise",
          params: {
            id: this.detailInfo.id,
          },
        });
      } else if (e == 11) {
        this.$router.push({
          name: "impactplan",
          params: {
            id: this.detailInfo.id,
          },
        });
      }
      setTimeout(()=>{
        this.checkSidebar()
        // this.scrollToSection('clickTab')
      },1000)

      // } else if (e == 8) {

      // }
    },
    // 切换显示元素的方法
    move(direction) {
      if (direction === -1 && this.startIndex > 0) {
        this.startIndex--;
      } else if (
        direction === 1 &&
        this.startIndex + this.visibleCount < this.allItems.length
      ) {
        this.startIndex++;
      }
    },
    // 点击确认加入团体
    qrbulletframe() {
      this.isLoading = true;
      this.toGroup_join(this.detailInfo.id);
    },
    // 点击加入团体
    bulletframe() {
      this.modalShow = true;
    },
    // 加入团体
    toGroup_join(id) {
      group_join({
        id: id,
      })
        .then((res) => {
          if (res.code == 200) {
            this.$bvToast.toast(this.$t("加入成功"), {
              title: this.$t("login.notice"),
              autoHideDelay: 2000,
              delay: 5000,
              appendToast: true,
              variant: "success",
            });
            setTimeout(() => {
              this.isLoading = false;
              this.modalShow = false;
              this.getDetail(this.id);
            }, 100);
          }
        })
        .catch(() => {});
    },
    // 退出团队
    backrame() {
      this.backGroup_leave();
    },
    // 退出团队接口
    backGroup_leave() {
      group_leave({
        id: this.detailInfo.id,
      }).then((res) => {
        // console.log(res, "离开团队");
        if (res.code == 200) {
          this.getDetail(this.id);
          this.$bvToast.toast(this.$t("離開成功"), {
            title: this.$t("login.notice"),
            autoHideDelay: 2000,
            delay: 5000,
            appendToast: true,
            variant: "success",
          });
        }else{
          this.$bvToast.toast(res.msg, {
          title: this.$t("login.warning"),
          autoHideDelay: 2000,
          delay: 5000,
          appendToast: true,
          variant: "danger",
        });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
@media screen and (max-width: 751px) {
}
@media screen and (max-width: 991px) {
  .boxClass {
    max-width: 100%!important;
    width: 100% !important;
  }
  .heggs {
    padding-bottom: 2vh !important;
  }
  .sjdsdsax {
    position: relative;
    background: #ffffff;
    text-align: center;
    width: 40% !important;
    display: inline-block;
  }
  .tpiand {
    display: none;
  }
  .sjtop {
    margin-top: 1rem !important;
  }
  .sjbgaodu {
    height: 200px !important;
    overflow: hidden !important;
  }
  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }
  .sjtoto {
    font-size: calc(16px + 0.4vw) !important;
  }
  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }
  .aaaa {
    display: block !important;
  }
  .yinc {
    display: none !important;
  }
  .sjiduand1 {
    padding: 12px !important;
  }
}
.aaaa {
  display: none;
}
.ckqbb:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  // padding: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.dcbd:hover {
  transform: scale(1.2);
  /* 悬浮时放大1.1倍 */
  // padding: 12px;
}
.sjdsdsax {
  position: relative;
  background: #ffffff;
  text-align: center;
  width: 30%;
  display: inline-block;
}
.item {
  width: 30%;
  background-color: red;
}

.jhsad {
  text-align: center;
  background: #fcd7d5;
  border-radius: 12px;
  height: calc(50px + 0.4vw);
  display: flex;
  justify-content: center;
  align-items: center;
}

.parent::-webkit-scrollbar {
  display: none;
}

.imase {
  ::v-deep .img-fluid {
    height: 408px !important;
    object-fit: cover !important;
  }
}
.dcbd:hover {
  transform: scale(1.2);
}
.dcbd:hover {
  transform: scale(1.2);
}
.hongdian {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #ff797a;
  margin: auto;
}

.hongdians {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
</style>